// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"addddcbe","260":"1b8382b5","703":"d9035bd7"}[chunkId] + ".chunk.js";
};